// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__OTJ_d","vLegacy":"SelectSecondary_vLegacy__32GHB","error":"SelectSecondary_error__38-_e","disabled":"SelectSecondary_disabled__2FgCO"};